package dev.akshaychordiya.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.setVariable
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.forms.ButtonVars
import dev.akshaychordiya.CircleButtonVariant
import dev.akshaychordiya.UncoloredButtonVariant
import org.jetbrains.compose.web.css.em

/**
 * A borderless, circular button sized for a single icon.
 *
 * [ariaLabel] is required rather than optional: an icon-only button with no accessible name is invisible to a screen
 * reader, and this widget is only ever used for icon-only buttons.
 */
@Composable
fun IconButton(onClick: () -> Unit, ariaLabel: String, content: @Composable () -> Unit) {
    Button(
        onClick = { onClick() },
        // Size the icon relative to the parent's font size, so the nav can scale it per breakpoint.
        Modifier
            .setVariable(ButtonVars.FontSize, 1.em)
            .attrsModifier { attr("aria-label", ariaLabel) },
        variant = CircleButtonVariant.then(UncoloredButtonVariant),
    ) {
        content()
    }
}
